import { isNewVersion } from 'Components/hooks/use-version'
import { VERSION_COOKIE_KEY, NEW_VERSION, OLD_VERSION } from 'lib/version'
import qs from 'qs'

export default function getUrl(path: string, psm?: string) {
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    if (path.startsWith('/cloud/api')) {
      return path
    }
    // return `/api${path}`
    return path
  }

  // 浏览器环境
  if (typeof window !== 'undefined') {
    return path
  }

  const domain =
    psm &&
    process.env.NODE_ENV !== 'development' &&
    process.env.TCE_HOST_ENV !== 'boe'
      ? `consul://${psm}`
      : 'https://www.dongchedi.com'

  console.log('domain-path', `${domain}${path}`)
  return `${domain}${path}`
}

export const urlWithVersion = (router: any, curUrl: string) => {
  if (!router) {
    return
  }
  const queryPrefixIndex = curUrl.indexOf('?')
  let query: { [key: string]: any } = {}
  let baseUrl = curUrl
  let newUrl = curUrl
  if (-1 !== queryPrefixIndex) {
    query = qs.parse(curUrl.substr(queryPrefixIndex + 1))
    baseUrl = curUrl.substr(0, queryPrefixIndex)
  }
  if (isNewVersion() && query?.[VERSION_COOKIE_KEY] !== NEW_VERSION) {
    query[VERSION_COOKIE_KEY] = NEW_VERSION
    newUrl = `${baseUrl}?${qs.stringify(query)}`
  } else if (!isNewVersion() && query?.[VERSION_COOKIE_KEY] !== OLD_VERSION) {
    query[VERSION_COOKIE_KEY] = OLD_VERSION
    newUrl = `${baseUrl}?${qs.stringify(query)}`
  }

  if (curUrl !== newUrl) {
    //router.push('/', newUrl, {
    //shallow: true
    //})
    window.history.replaceState(
      { ...window.history.state, as: newUrl, url: newUrl },
      '',
      newUrl
    )
  }
}
